import { connect } from 'react-redux';

import { ProductNameCell, ProductNameCellProps } from '../../components/ProductNameCell/ProductNameCell';
import { ProductAccess } from '../../typings/products';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

interface OwnProps {
    name: string;
    access: ProductAccess;
    placeIds: number[] | null;
    link: string;
}

type StateProps = TStateProps<ProductNameCellProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => ({
    productName: ownProps.name,
    productLink: ownProps.link,
    productAccess: ownProps.access,
    productPlaceIds: ownProps.placeIds,
    accessRights: state.commonData.accessRights
});

export const ProductNameCellContainer = connect<StateProps, null, OwnProps>(mapStateToProps)(ProductNameCell);
